import { motion } from "framer-motion";
import {
  BadgeCheck, Zap, Factory, Wrench, PauseCircle, Forklift,
  Scale, Ship, ShieldPlus, Car, FileCheck2, Award, HeadphonesIcon,
} from "lucide-react";

const ITEMS = [
  { icon: BadgeCheck, title: "Sin costo de cotización" },
  { icon: Zap, title: "Respuesta rápida" },
  { icon: Factory, title: "Todo Riesgo Industrial", note: "Planta, bodega, contenido y existencias", featured: true },
  { icon: Wrench, title: "Avería de maquinaria", note: "Rotura, falla eléctrica y error de operación" },
  { icon: PauseCircle, title: "Perjuicio por paralización", note: "Utilidad, gastos fijos y remuneraciones", featured: true },
  { icon: Forklift, title: "Equipos móviles y maquinaria", note: "Dentro y fuera de faena" },
  { icon: Scale, title: "Responsabilidad civil", note: "General, patronal y de productos", featured: true },
  { icon: Ship, title: "Transporte de carga", note: "Terrestre, marítimo y aéreo" },
  { icon: ShieldPlus, title: "Accidentes personales", note: "Colectivo para colaboradores" },
  { icon: Car, title: "Autos a precio flota", note: "Beneficio para tu equipo" },
  { icon: FileCheck2, title: "Garantías", note: "Fiel cumplimiento, seriedad de la oferta y anticipos" },
  { icon: Award, title: "Aseguradoras y reaseguradores", note: "Respaldo local e internacional" },
  { icon: HeadphonesIcon, title: "Ejecutivo asignado" },
];

export const Included = () => {
  return (
    <section id="incluye" className="scroll-mt-24 border-y border-gray-100 bg-gray-50/70 py-12 sm:scroll-mt-28 sm:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div>
          <p className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-brand-gold">
            <BadgeCheck className="h-4 w-4" /> Tu seguro incluye
          </p>
          <h2 className="font-display mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-brand-ink">
            Cobertura completa para toda tu operación.
          </h2>
          <p className="mt-4 max-w-2xl text-base sm:text-lg text-gray-600">
            Planta, maquinaria, equipos, flota, carga, contratos y personas. Beneficios
            reales para operar tranquilo en la faena, en la bodega y en la carretera.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:mt-12 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
          {ITEMS.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}
              data-testid={`included-item-${i}`}
              className={`group relative flex items-center gap-3.5 rounded-2xl border bg-white p-4 transition-all hover:-translate-y-0.5 hover:shadow-lg hover:shadow-brand-ink/5 ${
                it.featured ? "border-brand-yellow/60 ring-1 ring-brand-yellow/25" : "border-gray-200 hover:border-brand-yellow/50"
              }`}
            >
              <span
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl transition-transform group-hover:scale-105 ${
                  it.featured ? "bg-brand-yellow/20 text-brand-gold" : "bg-brand-ink/5 text-brand-ink"
                }`}
              >
                <it.icon className="h-5 w-5" />
              </span>
              <div className="min-w-0">
                <p className="font-display font-semibold leading-tight text-brand-ink">{it.title}</p>
                {it.note && (
                  <p className={`mt-0.5 text-xs font-medium ${it.featured ? "text-brand-ink/70" : "text-gray-500"}`}>
                    {it.note}
                  </p>
                )}
              </div>
              {it.featured && (
                <span className="absolute -top-2 right-4 rounded-full bg-brand-yellow px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-white shadow-sm">
                  Destacado
                </span>
              )}
            </motion.div>
          ))}
        </div>

        <p className="mt-6 text-xs text-gray-400">
          * Las coberturas y beneficios finales dependen de la póliza y aseguradora seleccionada en tu propuesta.
        </p>
      </div>
    </section>
  );
};
